"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconDefinitions = exports.CustomIconDefinitions = exports.FAIconDefinitions = void 0;
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var free_brands_svg_icons_1 = require("@fortawesome/free-brands-svg-icons");
var bible_svg_1 = require("../assets/icons/bible.svg");
var elective_svg_1 = require("../assets/icons/elective.svg");
var geography_svg_1 = require("../assets/icons/geography.svg");
var language_arts_svg_1 = require("../assets/icons/language-arts.svg");
var math_svg_1 = require("../assets/icons/math.svg");
var science_svg_1 = require("../assets/icons/science.svg");
var course_catalog_svg_1 = require("../assets/icons/course-catalog.svg");
var course_catalog_filled_svg_1 = require("../assets/icons/course-catalog.filled.svg");
var gradebook_svg_1 = require("../assets/icons/gradebook.svg");
var gradebook_filled_svg_1 = require("../assets/icons/gradebook.filled.svg");
var home_svg_1 = require("../assets/icons/home.svg");
var home_filled_svg_1 = require("../assets/icons/home.filled.svg");
var planner_svg_1 = require("../assets/icons/planner.svg");
var planner_filled_svg_1 = require("../assets/icons/planner.filled.svg");
var lock_svg_1 = require("../assets/icons/lock.svg");
var overdue_svg_1 = require("../assets/icons/overdue.svg");
var project_svg_1 = require("../assets/icons/project.svg");
var started_assignment_svg_1 = require("../assets/icons/started-assignment.svg");
var reschedule_svg_1 = require("../assets/icons/reschedule.svg");
var add_event_svg_1 = require("../assets/icons/add-event.svg");
var time_off_svg_1 = require("../assets/icons/time-off.svg");
var today_svg_1 = require("../assets/icons/today.svg");
var form_saved_svg_1 = require("../assets/images/form-saved.svg");
var group_svg_1 = require("../assets/icons/group.svg");
exports.FAIconDefinitions = {
    // Regular
    CALENDAR_DAY: pro_regular_svg_icons_1.faCalendarDay,
    CALENDAR: pro_regular_svg_icons_1.faCalendar,
    CALENDAR_PLUS: pro_regular_svg_icons_1.faCalendarPlus,
    CALENDAR_DAYS: pro_regular_svg_icons_1.faCalendarDays,
    CLOCK: pro_regular_svg_icons_1.faClock,
    BOOK: pro_regular_svg_icons_1.faBook,
    CIRCLE_QUESTION: pro_regular_svg_icons_1.faCircleQuestion,
    STAR: pro_regular_svg_icons_1.faStar,
    CALENDAR_STAR: pro_regular_svg_icons_1.faCalendarStar,
    OUTLINED_OPEN_BOOK: pro_regular_svg_icons_1.faBookOpen,
    NOTEBOOK: pro_regular_svg_icons_1.faNotebook,
    // Solid
    BOOK_OPEN: pro_solid_svg_icons_1.faBookOpen,
    CARET_DOWN: pro_solid_svg_icons_1.faCaretDown,
    INFO_CIRCLE: pro_solid_svg_icons_1.faInfoCircle,
    INFO: pro_solid_svg_icons_1.faInfo,
    PLUS: pro_solid_svg_icons_1.faPlus,
    X_MARK: pro_solid_svg_icons_1.faXmark,
    CHECK: pro_solid_svg_icons_1.faCheck,
    MENU: pro_solid_svg_icons_1.faBars,
    EYE: pro_solid_svg_icons_1.faEye,
    EYE_SLASH: pro_solid_svg_icons_1.faEyeSlash,
    WRENCH: pro_solid_svg_icons_1.faWrench,
    CHEVRON_DOWN: pro_solid_svg_icons_1.faChevronDown,
    CHEVRON_UP: pro_solid_svg_icons_1.faChevronUp,
    CHEVRON_LEFT: pro_solid_svg_icons_1.faChevronLeft,
    CHEVRON_RIGHT: pro_solid_svg_icons_1.faChevronRight,
    BARS_FILTER: pro_solid_svg_icons_1.faBarsFilter,
    ELLIPSIS: pro_solid_svg_icons_1.faEllipsis,
    CLOCK_ROTATE_LEFT: pro_solid_svg_icons_1.faClockRotateLeft,
    USER_GROUP_SOLID: pro_solid_svg_icons_1.faUserGroup,
    LIGHT_PENCIL: pro_light_svg_icons_1.faPencil,
    LIGHT_BOOKS: pro_light_svg_icons_1.faBooks,
    TROPHY: pro_solid_svg_icons_1.faTrophy,
    CAKE_CANDLES: pro_solid_svg_icons_1.faCakeCandles,
    BRIEFCASE_MEDICAL: pro_solid_svg_icons_1.faBriefcaseMedical,
    BUILDING_COLUMNS: pro_solid_svg_icons_1.faBuildingColumns,
    VAN_SHUTTLE: pro_solid_svg_icons_1.faVanShuttle,
    UMBRELLA_BEACH: pro_solid_svg_icons_1.faUmbrellaBeach,
    FAMILY: pro_solid_svg_icons_1.faFamily,
    LEAF: pro_regular_svg_icons_1.faLeaf,
    PERSON_SWIMMING: pro_solid_svg_icons_1.faPersonSwimming,
    PERSON_RUNNING: pro_solid_svg_icons_1.faPersonRunning,
    FACE_THERMOMETER: pro_regular_svg_icons_1.faFaceThermometer,
    LEFT_TO_LINE: pro_solid_svg_icons_1.faLeftToLine,
    STAR_SHARP_SOLID: pro_solid_svg_icons_1.faStarSharp,
    SUN_SOLID: pro_solid_svg_icons_1.faSun,
    SNOWFLAKE_SOLID: pro_solid_svg_icons_1.faSnowflake,
    PARTY_HORN_SOLID: pro_solid_svg_icons_1.faPartyHorn,
    CALENDAR_MINUS_REGULAR: pro_regular_svg_icons_1.faCalendarMinus,
    CIRCLE_PLAY: pro_solid_svg_icons_1.faCirclePlay,
    CIRCLE_CHECK: pro_solid_svg_icons_1.faCircleCheck,
    CIRCLE_X: pro_solid_svg_icons_1.faCircleXmark,
    // Brand
    BITBUCKET: free_brands_svg_icons_1.faBitbucket,
};
exports.CustomIconDefinitions = {
    // Subjects
    BIBLE: bible_svg_1.ReactComponent,
    GEOGRAPHY: geography_svg_1.ReactComponent,
    LANGUAGE_ARTS: language_arts_svg_1.ReactComponent,
    MATH: math_svg_1.ReactComponent,
    SCIENCE: science_svg_1.ReactComponent,
    ELECTIVE: elective_svg_1.ReactComponent,
    // Assignment Status
    PROJECT: project_svg_1.ReactComponent,
    OVERDUE: overdue_svg_1.ReactComponent,
    STARTED_ASSIGNMENT: started_assignment_svg_1.ReactComponent,
    LOCK: lock_svg_1.ReactComponent,
    // Navigational
    COURSE_CATALOG: course_catalog_svg_1.ReactComponent,
    COURSE_CATALOG_FILLED: course_catalog_filled_svg_1.ReactComponent,
    GRADEBOOK: gradebook_svg_1.ReactComponent,
    GRADEBOOK_FILLED: gradebook_filled_svg_1.ReactComponent,
    HOME: home_svg_1.ReactComponent,
    HOME_FILLED: home_filled_svg_1.ReactComponent,
    PLANNER: planner_svg_1.ReactComponent,
    PLANNER_FILLED: planner_filled_svg_1.ReactComponent,
    // Planner/Misc
    RESCHEDULE: reschedule_svg_1.ReactComponent,
    ADD_EVENT: add_event_svg_1.ReactComponent,
    TIME_OFF: time_off_svg_1.ReactComponent,
    TODAY: today_svg_1.ReactComponent,
    FORM_SAVED: form_saved_svg_1.ReactComponent,
    GROUP: group_svg_1.ReactComponent,
};
exports.IconDefinitions = __assign(__assign({}, exports.FAIconDefinitions), exports.CustomIconDefinitions);
